import React, { Component} from "react";
import { BrowserRouter } from "react-router-dom";
import {hot} from "react-hot-loader";
import Layout from "./pages/layout";

class App extends Component{
	render () {
		return(
			<BrowserRouter basename="/help">
				<Layout/>
			</BrowserRouter>
		);
	}
}

export default hot(module)(App);